<aside class="cv-photo-sub-content">
	<div [ngSwitch]="type">
		<cv-photo-content-sketch
			[info]="info"
			*ngSwitchCase="contentType.SKETCH"
		></cv-photo-content-sketch>
		<cv-photo-content-exterior
			[info]="info"
			[galleryOptions]="galleryOptions"
			*ngSwitchCase="contentType.EXTERIOR"
		></cv-photo-content-exterior>
		<cv-photo-content-interior
			[info]="info"
			[galleryOptions]="galleryOptions"
			*ngSwitchCase="contentType.INTERIOR"
		></cv-photo-content-interior>
		<div *ngSwitchCase="contentType.PROPERTY_CARD">
			<div class="property_info" *ngFor="let item of info">
				<label>Description</label>
				<p>{{ item.photoDescription }}</p>
			</div>
		</div>
	</div>
</aside>
